import includes from 'lodash/includes';

export default (types, message) => {
  const myMessage = message || 'Invalid file type';
  const myTypes = types instanceof Array ? types : [types];

  return value => ({
    isValid:
      (value instanceof Array || value instanceof Object) &&
      value[0] instanceof File &&
      includes(myTypes, value[0].type),
    message: myMessage,
  });
};



// WEBPACK FOOTER //
// ./src/common/utils/fileType.js